import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import config from "../../config";
import routes from "../../Config/routes";
import { useAuthState } from "../../Context";

const Home = () => {
  const { userGroup } = useAuthState();
  const [redirectPath, setRedirectPath] = useState(null);
  const [isLoading, setIsLoading] = useState(true); // Add a loading state

  useEffect(() => {
    const getFirstAccessibleFeature = () => {
      // Iterate through the feature flags to find the first enabled feature accessible to the user
      for (const featureKey in config.FEATURE_FLAGS) {
        const featureConfig = config.FEATURE_FLAGS[featureKey];
        if (featureConfig.enabled) {
          if (
            !featureConfig.roles || // If no roles are defined, everyone has access
            featureConfig.roles.some((role) => userGroup?.includes(role))
          ) {
            // Find the corresponding route for the feature
            const route = routes.find((r) => r.feature === featureKey);
            if (route) {
              return route.path; // Return the path of the first accessible feature
            }
          }
        }
      }
      return null; // No accessible feature found
    };

    const path = getFirstAccessibleFeature();
    // console.log("path to redirect:", path);
    setRedirectPath(path);
    setIsLoading(false); // Mark loading as complete
  }, [userGroup]);

  // Show a loading state while determining the redirect path
  if (isLoading) {
    // console.log("Home page is calculating redirect path");
    // return <div>Loading...</div>;
    return null;
  }

  // Redirect to the determined path
  if (redirectPath) {
    // console.log("redirect from home to path:", redirectPath);
    return <Navigate to={redirectPath} />;
  }

  // Fallback if no accessible route is found
  // return <div>You do not have access to any features. </div>;
  return null;
};

export default Home;